'use client'

import { useTranslations } from 'next-intl'

export default function Footer() {
  const t = useTranslations('component.Footer')

  return (
    <div className='bg-primary flex justify-center px-5 sm:px-10'>
      <footer className='footer footer-horizontal footer-center text-base-content container p-5'>
        <p>{t('title', { year: new Date().getFullYear() })}</p>
      </footer>
    </div>
  )
}
